import { render } from "./Copyright.vue?vue&type=template&id=48751646"
import script from "./Copyright.vue?vue&type=script&lang=ts"
export * from "./Copyright.vue?vue&type=script&lang=ts"

import "./Copyright.vue?vue&type=style&index=0&id=48751646&lang=scss"
script.render = render

export default script